<template>
  <TairoModal
    :classes="{
      wrapper: '!p-0 m-0 w-full items-stretch sm:min-h-full sm:items-center sm:justify-center sm:p-4 sm:text-center ',
      dialog: ' rounded-none sm:rounded-md flex flex-col h-screen sm:h-[80vh]',
    }"
    :open="locationModalOpen"
    size="2xl"
    @close="emit('modal-close')"
  >
    <template #header>
      <!-- Header -->
      <div class="flex w-full items-center justify-between p-4 md:p-6">
        <h3 class="font-heading text-muted-900 text-lg font-medium leading-6 dark:text-white">
          {{ t('prebooking.locations.select_locations') }}
        </h3>

        <BaseButtonClose @click="emit('modal-close')" />
      </div>
    </template>
    <!-- Body -->
    <div class="mx-4 mb-4">
      <BaseButton
        class="mr-4"
        @click="treeSelectRef.unselectAllChildren()"
      >
        Unselect all
      </BaseButton>
      <BaseButton
        @click="treeSelectRef.selectAllChildren()"
      >
        Select all
      </BaseButton>
    </div>
    <div class=" grow overflow-auto px-4 md:px-6 ">
      <BaseTreeSelect
        ref="treeSelectRef"
        v-model="selectedTreeLocations"
        class="overflow-x-hidden"
        :children="locations"
        treeline
      />
    </div>

    <template #footer>
      <!-- Footer -->
      <div class="p-4 md:p-6">
        <div class="flex gap-x-2">
          <BaseButton @click="emit('modal-close')">
            {{ t('general.cancel') }}
          </BaseButton>

          <BaseButton
            color="primary"
            variant="solid"
            @click="emit('update-locations', [...selectedTreeLocations])"
          >
            {{ t('general.update') }}
          </BaseButton>
        </div>
      </div>
    </template>
  </TairoModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import TairoModal from '../../../layers/tairo/components/TairoModal.vue'

export interface TreeItem {
  item: string
  open: boolean
  children?: TreeItem[]
}

const props = defineProps({
  locations: { type: Array as PropType<TreeItem[]>, required: true, default: null },
  selectedLocations: { type: Array as PropType<TreeItem[]>, required: true, default: null },
  locationModalOpen: { type: Boolean, required: true, default: false },
})

const emit = defineEmits(['update-locations', 'modal-close'])
const treeSelectRef = ref<any>(null)
onMounted(() => {
  // This has to run due to a bug in the treeselector where the UI gets disconnected from the underlying data
  // So we can not pass in the seclted items in the v-model. We ahve to click the check boxes manually
  setTimeout(() => {
    for (const location of props.selectedLocations) {
      const xpathResult = document.evaluate(
        `//div[span[text()="${location.item}"]]`,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null,
      )
      const targetDiv = xpathResult.singleNodeValue
      if (targetDiv) {
        // @ts-ignore
        targetDiv.querySelector('input').click()
      }
    }
  }, 200)
})

const { t } = useI18n()
// const selectedTreeLocations = ref([...props.selectedLocations])
// const selectedTreeLocations = ref([...props.selectedLocations.map((a) => { return { item: a.item } })])
const selectedTreeLocations = ref([])
</script>
